module.exports = __webpack_public_path__ + "img/fastcharger-rejected.b7f1e2ed.svg";